import Loadable from "react-loadable"
import Loading from "@/components/Loading"

export const Model = Loadable({
  loader: () => import("./Model"),
  loading: Loading
})
